import { render, staticRenderFns } from "./AiChatSidebar.vue?vue&type=template&id=71d70520"
import script from "./AiChatSidebar.vue?vue&type=script&lang=js"
export * from "./AiChatSidebar.vue?vue&type=script&lang=js"
import style0 from "./AiChatSidebar.vue?vue&type=style&index=0&id=71d70520&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports